module.exports = __webpack_public_path__ + "static/media/game-bosswrong2.22b7bd5f.png";